/**
 * @author yan st
 * @date 2022-08-30 13:51
 * @Description:
 */

export const homeRouter = [
  {
    path: "",
    redirect: "index",
  },
  {
    path: "index",
    meta: {
      title: "我的申报",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/index"),
  },
  // 项目月报
  {
    path: "project_month_report",
    meta: {
      title: "项目月报",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/month_report/index"),
  },
  // 项目月报列表
  {
    path: "project_month_report/list",
    meta: {
      title: "项目月报列表",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/month_report/month_report"),
  },
  // 项目月报填写
  {
    path: "project_month_report/report",
    meta: {
      title: "编辑项目月报",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/month_report/report"),
  },
  // 绩效指标
  {
    path: "project_performance",
    meta: {
      title: "绩效管理",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/performance/index"),
  },
  // 绩效指标列表
  {
    path: "project_performance/list",
    meta: {
      title: "绩效指标列表",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/performance/performance"),
  },
  // {
  //   path: "project_list/index",
  //   meta: {
  //     title: "月报填写",
  //     needLogin: true, // 是否需要登录才能访问
  //   },
  //   component: () => import("../views/orghome/page/project_list/index"),
  // },
  // {
  //   path: "project_list/detail",
  //   meta: {
  //     title: "月报填写",
  //     needLogin: true, // 是否需要登录才能访问
  //   },
  //   component: () => import("../views/orghome/page/project_list/detail"),
  // },
  {
    path: "project_list/index",
    meta: {
      title: "中期评审资料上传",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/project_list/index"),
  },
  {
    path: "project_list/detail",
    meta: {
      title: "中期评审资料上传",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/project_list/detail"),
  },
  {
    path: "project_list/upload_file",
    meta: {
      title: "中期评审资料上传-详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/project_list/upload_file"),
  },
  {
    path: "end_project_list/index",
    meta: {
      title: "结项评审资料上传",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/end_project_list/index"),
  },
  {
    path: "end_project_list/detail",
    meta: {
      title: "结项评审资料上传",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/end_project_list/detail"),
  },
  {
    path: "end_project_list/upload_file",
    meta: {
      title: "结项评审资料上传-详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () =>
      import("../views/orghome/page/end_project_list/upload_file"),
  },
  {
    path: "supply_project_list/index",
    meta: {
      title: "结项评审资料上传（补充）",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/supply_project_list/index"),
  },
  {
    path: "supply_project_list/detail",
    meta: {
      title: "结项评审资料上传（补充）",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/supply_project_list/detail"),
  },
  {
    path: "supply_project_list/upload_file",
    meta: {
      title: "结项评审资料上传（补充）-详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () =>
      import("../views/orghome/page/supply_project_list/upload_file"),
  },
  {
    path: "project",
    meta: {
      title: "我的申报（待补充资料）",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/project/index"),
  },
  {
    path: "loglist",
    meta: {
      title: "日志列表",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/loglist"),
  },
  {
    path: "pass",
    meta: {
      title: "修改密码",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/pass"),
  },
];

export default homeRouter;
